module.exports = __webpack_public_path__ + "static/ha11-b46d7d0a34f58dfa3476f4430b8c8261.jpg";